import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { openShareModal } from 'app/dispatcher/modalDispatcher';
import dynamic from 'next/dynamic';
import TruncateMarkup from 'app/components/post/TruncateMarkup';
import PostCardWrapper from 'app/components/post/PostCardWrapper';
import { SHARE_TYPE } from 'app/constants/app';
import { generateReviewLink } from 'app/utils/generateShareLink';
import reactStringReplace from 'react-string-replace';
import get from 'lodash/get';
import { Colors } from 'app/seedly-component-library';
import PostCommentForm from 'app/components/comment/PostCommentForm';
import ReviewCommentProvider from 'app/components/comment/CommentContext/ReviewCommentContext';
import useReviewMenu from './hooks/useReviewMenu';
import Header from './Header';

const Footer = dynamic(() => import('./Footer'));
const CommentList = dynamic(() => import('app/components/comment/CommentList'));

const replaceText = (text, filterTextList) => {
  const filterList = filterTextList.join('|');
  const regex = new RegExp(`(${filterList})`, 'i');

  return reactStringReplace(text, regex, (match, i) => (
    <span style={{ backgroundColor: Colors.blue2 }} key={i}>
      {match}
    </span>
  ));
};

const ReviewItem = props => {
  const dispatch = useDispatch();

  const { review, type, isPreview, truncate = 8 } = props;

  const menuOptions = useReviewMenu({ isPreview, review });

  const filterText = useSelector(state => state.review.meta.filterText);
  const filterTag = useSelector(state => state.review.meta.filterTag);
  const productCategoriesById = useSelector(
    state => state.product.productCategoriesById,
  );

  const {
    id: reviewId,
    product,
    reviewText,
    canCommentAsBusinessAccount,
    parentCommentsCount,
  } = review;

  const category = product
    ? get(productCategoriesById, `[${product.categoryId}].slug`, '')
    : '';

  const shareUrl = generateReviewLink(
    category,
    get(product, 'slug', ''),
    reviewId,
  );

  const textRendering = () => {
    const shouldReplace = filterText.length > 0 && filterTag;

    return shouldReplace ? (
      replaceText(reviewText, filterText)
    ) : (
      <span>{reviewText}</span>
    );
  };

  return (
    <PostCardWrapper menuOptions={menuOptions} testid="review-item-wrapper">
      <div data-testid="review-item">
        <Header type={type} review={review} category={category} />
      </div>
      <TruncateMarkup
        lines={truncate}
        renderDefault={textRendering}
        renderTruncate={textRendering}
      />
      {!isPreview && (
        <>
          <Footer
            review={review}
            openShareModal={() =>
              dispatch(openShareModal(SHARE_TYPE.REVIEW, shareUrl))
            }
          />
          <div
            className="flex flex-col w-full gap-4"
            direction="column"
            width="100%"
            align="start"
          >
            <div className="horizontal-divider" />
            <ReviewCommentProvider
              productId={product.id}
              canCommentAsBa={canCommentAsBusinessAccount}
            >
              <PostCommentForm
                commentableType="Review"
                commentableId={reviewId}
              />
              <CommentList
                totalCommentCount={parentCommentsCount}
                commentableId={reviewId}
                commentableType="Review"
                childCommentableType="ReviewComment"
                commentShareLink={shareUrl}
              />
            </ReviewCommentProvider>
          </div>
        </>
      )}
    </PostCardWrapper>
  );
};

export default ReviewItem;
